/*
 * @Description:对象管理--系统对象/外部对象/全局字段
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  或: '或',
  系统: '系统',
  必填: '必填',
  启用: '启用',
  停用: '停用',
  状态: '状态',
  参数: '参数',
  字段ID: '字段ID',
  类型: '类型',
  非必填: '非必填',
  选项值: '选项值',
  新建对象: '新建对象',
  系统对象: '系统对象',
  对象名称: '对象名称',
  对象类型: '对象类型',
  自动获取字段: '自动获取字段',
  '自动获取飞书审批字段，可能会对您现有配置产生更新，是否确认': '自动获取飞书审批字段，可能会对您现有配置产生更新，是否确认',
  新建字段: '新建字段',
  字段名称: '字段名称',
  字段设置: '字段设置',
  字段标识: '字段标识',
  字段类型: '字段类型',
  是否必填: '是否必填',
  视图: '视图',
  创建视图: '创建视图',
  系统视图: '系统视图',
  公共视图: '公共视图',
  全部成员: '全部成员',
  视图名称: '视图名称',
  视图类型: '视图类型',
  适用范围: '适用范围',
  编辑视图: '编辑视图',
  数据条件: '数据条件',
  外部对象: '外部对象',
  添加字段: '添加字段',
  新增字段: '新增字段',
  编辑字段: '编辑字段',
  设置选项: '设置选项',
  添加选项: '添加选项',
  批量添加: '批量添加',
  '每行可输入一个选项，回车键可换行': '每行可输入一个选项，回车键可换行',
  '可输入选项名称和apiname，可用英文冒号隔开。例如【男:man】': '可输入选项名称和apiname，可用英文冒号隔开。例如【男:man】',
  单选按钮: '单选按钮',
  多选按钮: '多选按钮',
  下拉单选: '下拉单选',
  下拉多选: '下拉多选',
  级联选择: '级联选择',
  审批定义code: '审批定义code',
  自定义字段: '自定义字段',
  新增或关系: '新增或关系',
  新增审批模板: '新增审批模板',
  编辑审批模板: '编辑审批模板',
  状态更新失败: '状态更新失败',
  监听的字段编码: '监听的字段编码',
  修改字段状态失败: '修改字段状态失败',
  系统字段不允许修改: '系统字段不允许修改',
  监听的合同类型缩写: '监听的合同类型缩写',
  字段详情获取失败: '字段详情获取失败',
  新增全局字段信息失败: '新增全局字段信息失败',
  获取全局字段列表失败: '获取全局字段列表失败',
  编辑全局字段信息失败: '编辑全局字段信息失败',
  字段名称信息校验失败: '字段名称信息校验失败',
  数据条件筛选不符合规则: '数据条件筛选不符合规则',
  数据对象: '数据对象',
  请输入姓名: '请输入姓名',
  请选择部门: '请选择部门',
  部门人数: '部门人数',
  部门负责人: '部门负责人',
  组织用户: '组织用户',
  离职人员列表: '离职人员列表',
  转移数据: '转移数据',
  离职日期: '离职日期',
  接收人员: '接收人员',
  新增规则: '新增规则',
  角色名: '角色名',
  角色名不能为空: '角色名不能为空',
  '请输入姓名/部门': '请输入姓名/部门',
  角色名不能超过100个字: '角色名不能超过100个字',
  请选择一个人员: '请选择一个人员',
  请选择接收人员: '请选择接收人员',
  查重已关闭: '查重已关闭',
  请开启查重: '请开启查重',
  联合查重客户: '联合查重客户',
  搜索字段名称: '搜索字段名称',
  搜索视图名称: '搜索视图名称',
  是否开启查重: '是否开启查重',
  请输入视图名称: '请输入视图名称',
  视图名称为必选项: '视图名称为必选项',
  视图类型为必选项: '视图类型为必选项',
  '查重条件不能为空，请重新设置': '查重条件不能为空，请重新设置',
  复制视图: '复制视图',
  自定义选项: '自定义选项',
  使用全局字段: '使用全局字段',
  请设置选项名称: '请设置选项名称',
  请设置选项值: '请设置选项值',
  示例: '示例',
  不限: '不限',
  编码: '编码',
  前编码: '前编码',
  后编码: '后编码',
  不启用: '不启用',
  数据格式: '数据格式',
  日期格式: '日期格式',
  范围格式: '范围格式',
  字段示例: '字段示例',
  关联对象: '关联对象',
  编码预览: '编码预览',
  插入年份: '插入年份',
  插入月份: '插入月份',
  插入日期: '插入日期',
  流水位数: '流水位数',
  今日及以前: '今日及以前',
  今日及以后: '今日及以后',
  请输入前编码: '请输入前编码',
  请输入后编码: '请输入后编码',
  支持文件类型: '支持文件类型',
  最大文件数量: '最大文件数量',
  支持输入大小写字母组合: '支持输入大小写字母组合',
  支持输入字母数字下划线组合: '支持输入字母数字下划线组合',
  支持输入字母数字组合: '支持输入字母数字组合',
  支持输入字母下划线组合: '支持输入字母下划线组合',
  请按规则输入字段标识: '请按规则输入字段标识',
  请选择数据格式: '请选择数据格式',
  请输入计算公式内容: '请输入计算公式内容',
  请选择日期格式: '请选择日期格式',
  选项值为必填项: '选项值为必填项',
  关联对象为必选项: '关联对象为必选项',
  请选择全局字段类型: '请选择全局字段类型',
  单个文件不得超过300M: '单个文件不得超过300M',
  请选择支持的文件类型: '请选择支持的文件类型',
  '最大文件数量不能为空,请重新设置': '最大文件数量不能为空,请重新设置',
  '支持文件类型不能为空,请重新设置': '支持文件类型不能为空,请重新设置',
  请输入对象名称: '请输入对象名称',
  请选择对象类型: '请选择对象类型',
  '请输入id/code值': '请输入id/code值',
  请输入监听的字段编码: '请输入监听的字段编码',
  请输入合同类型: '请输入合同类型',
  任务描述: '任务描述',
  完成条件: '完成条件',
  条件类型: '条件类型',
  空任务: '空任务',
  请选择对象: '请选择对象',
  请输入任务描述: '请输入任务描述',
  '云文档/附件类型': '云文档/附件类型',
  '请选择云文档/附件类型': '请选择云文档/附件类型',
  '多用于线下辅助的任务，起提醒作用': '多用于线下辅助的任务，起提醒作用',
  请输入接口参数: '请输入接口参数',
  请设置选项key值: '请设置选项key值',
  请设置选项value值: '请设置选项value值',
  请选择映射类型: '请选择映射类型',
  请选择来源对象: '请选择来源对象',
  请选择字段: '请选择字段',
  请选择映射至对象: '请选择映射至对象',
  请选择映射对象和源对象对应的字段值: '请选择映射对象和源对象对应的字段值',
  自定义视图: '自定义视图',
  外部页面视图: '外部页面视图',
  视图设置: '视图设置',
  查重设置: '查重设置',
  布局设置: '布局设置',
  按钮设置: '按钮设置',
  显示停用字段: '显示停用字段',
  分配布局: '分配布局',
  列表页布局: '列表页布局',
  详情页布局: '详情页布局',
  新建页布局: '新建页布局',
  编辑页布局: '编辑页布局',
  引用自: '引用自',
  引用自为必选项: '引用自为必选项',
  请选择引用自: '请选择引用自',
  引用字段: '引用字段',
  引用字段为必选项: '引用字段为必选项',
  请选引用字段: '请选引用字段',
  可选数量: '可选数量',
  可选一个部门: '可选一个部门',
  可选多个部门: '可选多个部门',
  请输入单位: '请输入单位',
  省略末尾的0: '省略末尾的0',
  '单位仅用于展示，不参与计算；': '单位仅用于展示，不参与计算；',
  '数据格式选择百分比时，单位值不可修改': '数据格式选择百分比时，单位值不可修改',
  '勾选后，当不足小数位数时省略末尾的0。如设置保留3位小数时，默认显示完整小数位数为1.600，勾选后则显示为1.6': '勾选后，当不足小数位数时省略末尾的0。如设置保留3位小数时，默认显示完整小数位数为1.600，勾选后则显示为1.6',
  选择计算类型: '选择计算类型',
  计算公式: '计算公式',
  请选择主对象: '请选择主对象',
  请选择关联对象: '请选择关联对象',
  请选择对象下字段: '请选择对象下字段',
  请选择汇总类型: '请选择汇总类型',
  汇总类型: '汇总类型',
  '计算关联对象的数据条目数，如：客户下的订单数量': '计算关联对象的数据条目数，如：客户下的订单数量',
  '计算某数字型字段的求和值，如：订单下产品数量合计': '计算某数字型字段的求和值，如：订单下产品数量合计',
  汇总字段: '汇总字段',
  请选择汇总字段: '请选择汇总字段',
  请选择数据范围: '请选择数据范围',
  数据范围: '数据范围',
  满足关联关系的所有数据: '满足关联关系的所有数据',
  自定义数据范围: '自定义数据范围',
  请输入计算公式: '请输入计算公式',
  插入字段: '插入字段',
  搜索插入字段: '搜索插入字段',
  插入运算符: '插入运算符',
  插入函数: '插入函数',
  其他设置: '其他设置',
  语法检查: '语法检查',
  请选择空白字段设置: '请选择空白字段设置',
  空白字段设置: '空白字段设置',
  主对象: '主对象',
  计算类型: '计算类型',
  百分比: '百分比',
  数字: '数字',
  金额: '金额',
  文本: '文本',
  空白字段默认为1: '空白字段默认为1',
  空白字段默认为0: '空白字段默认为0',
  '数字（汇总累计）': '数字（汇总累计）',
  '金额（汇总累计）': '金额（汇总累计）',
  '计算结果等于数字，示例：总数量 = 购买数量 + 赠送数量': '计算结果等于数字，示例：总数量 = 购买数量 + 赠送数量',
  '计算结果自动加百分比，示例：折扣 = 折后价 / 原价': '计算结果自动加百分比，示例：折扣 = 折后价 / 原价',
  '计算结果等于金额，示例：总金额 = 单价 * 数量': '计算结果等于金额，示例：总金额 = 单价 * 数量',
  '计算结果等于文本，一般用于串联其他字段，示例：商机名称 = CONCATENATE(客户名称 ， 创建日期)': '计算结果等于文本，一般用于串联其他字段，示例：商机名称 = CONCATENATE(客户名称 ， 创建日期)',
  '计算结果等于数字，一般用于汇总关联对象的数量，示例：统计客户下订单数量': '计算结果等于数字，一般用于汇总关联对象的数量，示例：统计客户下订单数量',
  '计算结果等于金额，一般用于汇总关联对象的金额，示例：统计客户下所有订单总金额': '计算结果等于金额，一般用于汇总关联对象的数量，示例：统计客户下所有订单总金额',
  对象标识: '对象标识',
  对象图标: '对象图标',
  请选择对象图标: '请选择对象图标',
  主属性字段: '主属性字段',
  按钮名称: '按钮名称',
  按钮类型: '按钮类型',
  按钮标识: '按钮标识',
  按钮位置: '按钮位置',
  按钮图标: '按钮图标',
  展示方式: '展示方式',
  说明: '说明',
  '图标+文字展示': '图标+文字展示',
  文字展示: '文字展示',
  图标展示: '图标展示',
  '列表布局-通用操作': '列表布局-通用操作',
  '列表布局-批量操作': '列表布局-批量操作',
  '列表布局-快捷操作': '列表布局-快捷操作',
  布局名称: '布局名称',
  是否展示: '是否展示',
  新建布局: '新建布局',
  编辑布局: '编辑布局',
  详情布局: '详情布局',
  通用按钮: '通用按钮',
  可选按钮: '可选按钮',
  已选按钮: '已选按钮',
  批量操作按钮: '批量操作按钮',
  快捷操作按钮: '快捷操作按钮',
  显示1个: '显示1个',
  显示2个: '显示2个',
  显示3个: '显示3个',
  显示4个: '显示4个',
  请输入说明信息: '请输入说明信息',
  '停用后该对象无法再新增数据，是否确认？': '停用后该对象无法再新增数据，是否确认？',
  导入设置: '导入设置',
  搜索对象名称: '搜索对象名称',
  请输入字段标识: '请输入字段标识',
  '自定义对象下已存有数据，不能直接删除对象': '自定义对象下已存有数据，不能直接删除对象',
  '删除后该自定义对象将不再可见，是否确认？': '删除后该自定义对象将不再可见，是否确认？',
  主属性字段设置: '主属性字段设置',
  数据权限设置: '数据权限设置',
  私有: '私有',
  全员公开: '全员公开',
  '登录人数据权限不同，看到的数据范围不同，上级部门的部门负责人可以看到下级部门的所有数据。': '登录人数据权限不同，看到的数据范围不同，上级部门的部门负责人可以看到下级部门的所有数据。',
  '数据可以设置协作人，且可以对协作人指定是读写、只读权限': '数据可以设置协作人，且可以对协作人指定是读写、只读权限',
  '数据在全租户内共享，与登录人的数据权限无关': '数据在全租户内共享，与登录人的数据权限无关',
  租户内每个人都能看到这个对象下的所有数据: '租户内每个人都能看到这个对象下的所有数据',
  '该对象的主属性字段，可理解为该条数据的“标题”': '该对象的主属性字段，可理解为该条数据的“标题”',
  只能将一个单行文本或编码字段作为主属性字段: '只能将一个单行文本或编码字段作为主属性字段',
  数据权限范围内: '数据权限范围内',
  符合条件的数据: '符合条件的数据',
  下拉显示字段: '下拉显示字段',
  请选择下拉显示字段: '请选择下拉显示字段',
  弹窗显示字段: '弹窗显示字段',
  设置数据条件: '设置数据条件',
  请完善数据条件: '请完善数据条件',
  属于当前操作人: '属于当前操作人',
  当前时间: '当前时间',
  属于当前操作人部门: '属于当前操作人部门',
  最多可选5个字段: '最多可选5个字段',
  审批组织: '审批组织',
  请输入审批组织: '请输入审批组织',
  子字段设置: '子字段设置',
  子表单数量超出限额: '子表单数量超出限额',
  '请确定最新的字段属性！': '请确定最新的字段属性！',
  '此计算公式配置有误，请重新设置': '此计算公式配置有误，请重新设置',
  '此项配置有误，请检查字段属性': '此项配置有误，请检查字段属性',
  '该字段删除后无法被恢复，请确认是否要删除？': '该字段删除后无法被恢复，请确认是否要删除？',
  从左侧拖拽添加字段: '从左侧拖拽添加字段'
};
